import api from '../utils/api';
import {
  UPDATESETTING
} from './types';
import  {store}  from '../store.js';

// update req User
export const updateVersion = (version) => async dispatch => {
  return new Promise(async function(resolve, reject) {
    const body = { version };
    let setting = store.getState().setting;
    const res = await api.post('/updateVersion', body);
    if(res.data.status == 1){
        // console.log(res.data)
        let newSettings;
        if(res.data.data == "add"){
            let dic = {type: 'version', value: version};
            newSettings = setting;
            newSettings.push(dic);
        }else{
            newSettings = setting.map(item => {
                if(item.type == 'version') {
                item.value = version;
                }
                return item;
            })
        }
      dispatch({
        type: UPDATESETTING,
        payload: newSettings
      });
      resolve(true);
    }else{
      resolve(false);
    }
  })
};
